import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Projects from '../components/Projects';
import CTA from '../components/CTA';
import Footer from '../components/Footer';
import CursorGlow from '../components/CursorGlow';
import BackgroundEffects from '../components/BackgroundEffects';
import useScrollReveal from '../hooks/useScrollReveal';
import SEO from '../components/SEO';
import '../styles/Sections.css';

const ProjectsPage = () => {
  useScrollReveal();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SEO 
        title="Proyectos" 
        description="Explora nuestro portafolio de soluciones digitales. Proyectos innovadores que demuestran nuestra experiencia en desarrollo web, apps móviles y diseño digital."
        keywords="portafolio, proyectos web, desarrollo de software, casos de éxito, Monologic Solutions"
      />
      <CursorGlow />
      <BackgroundEffects />
      <Navbar />
      <Projects />
      <CTA />
      <Footer />
    </>
  );
};

export default ProjectsPage;
